import { deriveDocStatus } from "@/components/documents/DocStatusPill";

export const SUGGESTION_DEFINITIONS = [
  {
    key: "no_documents_dashboard",
    page: "dashboard",
    icon: "UploadCloud",
    condition: (data) => (data?.hero?.documents_under_surveillance ?? 0) === 0,
    ctaHref: "/upload",
  },
  {
    key: "no_documents_library",
    page: "documents",
    icon: "UploadCloud",
    condition: (data) => (data?.docs?.length ?? 0) === 0,
    ctaHref: "/upload",
  },
  {
    key: "needs_review",
    page: "documents",
    icon: "AlertTriangle",
    condition: (data) => (data?.docs ?? []).some((d) => deriveDocStatus(d) === "needs_review"),
    countFn: (data) => (data?.docs ?? []).filter((d) => deriveDocStatus(d) === "needs_review").length,
    ctaHref: "/documents?status=needs_review",
  },
  {
    key: "expiring_soon",
    page: "documents",
    icon: "CalendarClock",
    condition: (data) => (data?.docStats?.expiring_soon_count ?? 0) > 0,
    countFn: (data) => data?.docStats?.expiring_soon_count ?? 0,
    ctaHref: "/documents?sort=due_date",
  },
  {
    key: "crosscheck_available",
    page: "documents",
    icon: "GitCompareArrows",
    condition: (data) => (data?.docStats?.crosscheck_candidates_count ?? 0) > 0,
    countFn: (data) => data?.docStats?.crosscheck_candidates_count ?? 0,
    ctaHrefFn: (data) => {
      const c = data?.docStats?.crosscheck_first_candidate;
      return c ? `/analysis/${c.doc_id}` : "/crosscheck";
    },
  },
  {
    key: "missing_document",
    page: "documents",
    icon: "FileWarning",
    condition: (data) => (data?.docStats?.missing_document_candidates_count ?? 0) > 0,
    countFn: (data) => data?.docStats?.missing_document_candidates_count ?? 0,
    ctaHrefFn: (data) => {
      const c = data?.docStats?.missing_document_first_candidate;
      return c ? `/upload?doc_type=${c.missing_type}` : "/upload";
    },
  },
];
